<app-header></app-header>
<div class="content">
  <div *ngIf="!isUserLoggedIn()" class="form-recharge">
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <input name="productId" type="hidden"/>
      <input name="productName" type="hidden"/>
      <div class="main-title dashboard-title"><span>Telefon oraz Internet satelitarny</span></div>
      <div class="description">
      <span class="body">
          Wybierz plan taryfowy odpowiedni dla Ciebie i załóż konto.<br/>
          Dzięki temu zyskasz możliwość:
          <ul>
              <li>podglądu w rejestr połączeń,</li>
              <li>aktualne saldo, jego aktywny monitoring,</li>
              <li>szybkiego doładowania oraz zmiany planu taryfowego</li>
              <li>wsparcia naszego zespołu</li>
          </ul>
      </span>
      </div>
      <div class="recharge-options">
        <div class="title">
          Wybierz plan taryfowy do połączeń głosowych w sieci Iridium
          <p class="small75">(wymaga aparatu telefonicznego pracującego w sieci Iridium)</p>
        </div>
        <app-price-plan-buttons (selectPackagePlan)="selectPackagePlan($event)" [plans]="filterPlans(0,3)"/>
        <app-price-plan-buttons (selectPackagePlan)="selectPackagePlan($event)" [plans]="filterPlans(3,6)"/>
        <app-price-plan-buttons (selectPackagePlan)="selectPackagePlan($event)" [plans]="filterPlans(6,8)"/>
      </div>
      <br/>
      <div class="recharge-options">
        <div class="title">
          Wybierz plan taryfowy do połączeń głosowych w sieci Iridium
          <p class="small75">(wymaga modemu Iridium GO!)</p>
        </div>
        <app-price-plan-buttons (selectPackagePlan)="selectPackagePlan($event)" [plans]="filterPlans(8,11)"/>
      </div>
    </form>
    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>

  <div *ngIf="isUserLoggedIn()" class="dashboard">
    <app-dashboard>

    </app-dashboard>
  </div>
</div>
